export default {
  promoTicketCard: 'dt.promotions.promoTicketCard',
  promoCard: 'dt.promotions.promoCard',
  bonusCountdown: 'dt.promotions.bonusCountdown',
  myPromotions: {
    enterPromoCodeButton: 'dt.promotions.myPromotions.enterPromoCodeButton',
    allTab: 'dt.promotions.myPromotions.allTab',
    vouchersTab: 'dt.promotions.myPromotions.vouchersTab',
    boostsTab: 'dt.promotions.myPromotions.boostsTab',
    depositBonusTab: 'dt.promotions.myPromotions.depositBonusTab',
  },
  promoCodeForm: {
    container: 'dt.promotions.promoCodeForm.container',
    input: 'dt.promotions.promoCodeForm.input',
    applyButton: 'dt.promotions.promoCodeForm.applyButton',
  },
  bonusModal: {
    title: 'dt.promotions.bonusModal.title',
    actionButton: 'dt.promotions.bonusModal.actionButton',
    error: 'dt.promotions.bonusModal.error',
  },
};
